import {currentBreakpoint} from '../lib/responsive';
import {trigger} from '../lib/event';
import {animationEndEventName, transitionEndEventName, getClosestByClass, isChildNode} from '../lib/helper';
import {standardListener, elHTML} from '../config/vars';
import {debounce, toArray} from 'lodash';

const animationEnd = animationEndEventName();
const transitionEnd = transitionEndEventName();
let lastY;
let distance = 0;

export default class Header {

  constructor(el) {

    this.isIOS = elHTML.classList.contains('is-ios');
    this.isMobileSafari9 = elHTML.classList.contains('is-mobile-safari-9');
    this.isMobile = false;
    this.isTouch = false;
    this.isActive = false;
    this.isSticky = false;
    this.isGuest = false;
    this.isOutsideClickHandlerRegistered = false;
    this.formFocusIsBound = false;
    this.formCloseIsUnbound = false;
    this.openFormListener = 'mouseover';
    this.closeFormListener = 'mouseleave';
    this.offset = 0;

    this.el = el;

    this.body = document.querySelector('html');

    this.outerWraper = elHTML.querySelector('.outer-wrapper');
    this.metaNav = this.el.querySelector('.meta-nav');
    this.cartEntry = elHTML.querySelector('.tc-sticky-cart-entry');
    this.cartContent = elHTML.querySelector('.tc-cart-content');
    this.mobileMenuTrigger = this.el.querySelector('.tc-menu-trigger');
    this.mobileMenuClose = this.el.querySelector('.tc-menu-close');
    this.loginFormTrigger = this.metaNav.querySelector('.tc-open-login-form');
    this.mobileLoginFormCloseTrigger = this.el.querySelector('.tc-close-login-form');
    this.loginForm = this.metaNav.querySelector('.tc-login-form');
    this.mobileLoginForm = this.el.querySelector('.tc-mobile-login-form');
    this.offCanvas = this.el.querySelector('.tc-offcanvas');
    this.search = this.el.querySelector('#search');
    this.childLists = [].slice.call(this.el.querySelectorAll('.child-list'));
    this.cartButton = this.metaNav.querySelector('.button-cart');
    this.userMenu = this.metaNav.querySelector('.usermenu');

    if (this.loginFormTrigger !== null) {

      this.isGuest = true;
    } else {

      this.userMenuToggle = this.metaNav.querySelector('.usermenu-toggle');
      this.userMenuClose = this.metaNav.querySelector('.usermenu-close');
      this.positionUserMenu();
    }

    if (this.search) {

      this.searchButton = this.search.querySelector('button');
      this.searchInput = this.search.querySelector('input');

      this.singleSearch = this.metaNav.querySelector('.is-mobile-single-search');
    }

    // TODO: needs different selector
    this.parentMenuItems = toArray(this.el.querySelectorAll('.is-nav'));

    this.closeSecondLevelItems = toArray(this.el.querySelectorAll('.close-second-level'));
    this.closeThirdLevelItems = toArray(this.el.querySelectorAll('.close-third-level'));

    this.onScrollHandler = debounce(this.onScroll.bind(this), 150);
    this.onRemoveClasses = this.removeClasses.bind(this);
    this.onAddClasses = this.addClasses.bind(this);
    this.onRemoveResettedClass = this.removeResettedClass.bind(this);
    this.onOutSideSearchClick = this.outSideSearchClick.bind(this);
    this.onOutSideLoginFormClick = this.outSideLoginFormClick.bind(this);
    this.onOpenLoginForm = this.openLoginForm.bind(this);
    this.onCloseLoginForm = this.closeLoginForm.bind(this);
    this.onFormFocusHandler = this.onFormFocus.bind(this);
    this.onFormClickOutsideHandler = this.onFormClickOutside.bind(this);

    this.onMobileSingleSearch = this.mobileSingleSearch.bind(this);

    this.onRemoveOffCanvasClass = this.removeOffCanvasClass.bind(this);

    //this.disableTouchHandler = this.disableTouch.bind(this);

    //this.offset = this.el.clientHeight;
    this.offset = window.getComputedStyle(this.el).height.replace('px', '') + 0;

    if (this.cartEntry !== null) {

      this.cartEntryHeight = this.cartEntry.getBoundingClientRect().height;
    }

    if (currentBreakpoint === 's' || currentBreakpoint === 'xs') {

      this.isMobile = true;
      this.openFormListener = standardListener;
    }

    if (elHTML.classList.contains('touchevents')) {

      this.isTouch = true;

      this.openFormListener = standardListener;
      // NOTE: What does this do?
      //document.addEventListener('touchstart', this.outSideMenuDropdownClick, false);
    }

    this.registerEvents();

    // TODO: we only need this above BP S!
    this.onScroll();
  }

  // TODO: move assingment to constructor
  handleBreakpointChange() {

    this.closeUserMenu();
    if (this.isGuest) {

      this.loginFormTrigger.removeEventListener(this.openFormListener, this.onOpenLoginForm, false);
      this.loginFormTrigger.removeEventListener(this.closeFormListener, this.onCloseLoginForm, false);
    }

    if (currentBreakpoint === 's' || currentBreakpoint === 'xs') {

      this.isMobile = true;
      this.openFormListener = standardListener;

      trigger(window, 'headerChange', {});
      // this.el.classList.remove('is-active');

      if (this.cartEntry !== null) {

        this.cartEntry.classList.remove('is-sticky');
        this.cartContent.style.marginTop = '';
      }

    } else {

      this.isMobile = false;
      this.openFormListener = 'mouseover';
      this.closeFormListener = 'mouseleave';

      if (this.isGuest) {

        this.mobileLoginForm.classList.remove('is-open');
      }

      if (this.isTouch === false) {

        if (this.isGuest) {

          this.loginFormTrigger.addEventListener(this.closeFormListener, this.onCloseLoginForm, false);
        }
      }
    }

    if (this.isGuest) {

      this.loginFormTrigger.addEventListener(this.openFormListener, this.onOpenLoginForm, false);
    }

    this.positionUserMenu();
  }

  registerEvents() {

    window.addEventListener('changeBreakpoint', this.handleBreakpointChange.bind(this));
    window.addEventListener('scroll', this.onScrollHandler, Modernizr.passiveeventlisteners ? {
      passive: true
    } : false);

    if (this.mobileMenuTrigger) {
      this.mobileMenuTrigger.addEventListener(standardListener, this.openMobileMenu.bind(this), false);
    }
    if (this.mobileMenuClose) {
      this.mobileMenuClose.addEventListener(standardListener, this.closeMobileMenu.bind(this), false);
    }

    if (this.isGuest) {

      this.loginFormTrigger.addEventListener(this.openFormListener, this.onOpenLoginForm, false);
      this.loginFormTrigger.addEventListener(this.closeFormListener, this.onCloseLoginForm, false);
      this.mobileLoginFormCloseTrigger.addEventListener(standardListener, this.closeMobileLoginForm.bind(this), false);
    }

    //this.searchButton.addEventListener(standardListener, this.handleSearch.bind(this), false);

    if (this.mobileMenuTrigger) {

      this.mobileMenuTrigger.addEventListener(standardListener, this.openMobileMenu.bind(this), false);
    }

    if (this.mobileMenuClose) {

      this.mobileMenuClose.addEventListener(standardListener, this.closeMobileMenu.bind(this), false);
    }

    if (this.userMenuToggle) {

      this.userMenuToggle.addEventListener(standardListener, (e) => {

        e.preventDefault();
        this.body.classList.toggle('has-menu-open');
        this.userMenu.classList.toggle('is-open');
      } );

      this.userMenuToggle.addEventListener('mouseenter',this.openUserMenu.bind(this),false);
    }
    if (this.userMenuClose) {

      this.userMenuClose.addEventListener(standardListener,this.closeUserMenu.bind(this),false);
    }

    if (this.search) {

      this.searchButton.addEventListener(standardListener, this.handleSearch.bind(this), false);
      this.singleSearch.addEventListener(standardListener, this.onMobileSingleSearch.bind(this), false);
      this.search.addEventListener('submit', this.handleSubmit.bind(this), false);
    }

    // if ( this.singleSearch ) {
    //
    //   this.singleSearch.addEventListener(standardListener, this.onMobileSingleSearch.bind(this), false);
    // }

    this.parentMenuItems.map(menuItem => {

      menuItem.addEventListener(standardListener, this.openSecondLevel.bind(this, menuItem));
      if (this.isIOS) {

        menuItem.addEventListener('touchend', this.touchEnd.bind(this, menuItem));
      }
    });

    this.closeSecondLevelItems.map(item => {

      item.addEventListener(standardListener, this.closeSecondLevel.bind(this));
    });

    this.closeThirdLevelItems.map(item => {

      item.addEventListener(standardListener, this.closeThirdLevel.bind(this));
    });
  }

  mobileSingleSearch(e) {

    if (this.isMobileSafari9 || !window.scrollTo) {

      window.scrollTop = 0;
    } else {

      window.scrollTo(0, 0);
    }

    this.el.classList.remove('is-single');

    // let searchInputVisibillity = window.getComputedStyle(this.searchInput).visibility;

    if (this.search.classList.contains('is-open')) {

      if (this.searchInput.value.length) {

        return this.search.submit();
      }
    }

    if (!this.search.classList.contains('is-open')) {

      window.setTimeout(() => {
        this.search.classList.add('is-open');
        this.searchInput.focus();

        if (!this.isOutsideClickHandlerRegistered) {
          document.addEventListener(standardListener, this.onOutSideSearchClick, false);
          this.isOutsideClickHandlerRegistered = true;
        }
      });
      e.preventDefault();
    }

  }

  unregisterEvents() {

    window.removeEventListener('scroll', this.onScrollHandler, Modernizr.passiveeventlisteners ? {
      passive: true
    } : false);
  }

  openLoginForm(e) {

    e.preventDefault();

    if (!this.isMobile) {

      this.loginForm.classList.add('is-open');

      if (!this.formFocusIsBound) {

        this.loginForm.addEventListener('focusin', this.onFormFocusHandler, false);
      }

      if (this.isTouch) {

        document.addEventListener('touchstart', this.onOutSideLoginFormClick, Modernizr.passiveeventlisteners ? {
          passive: true
        } : false);

        this.loginFormTrigger.classList.add('is-active');
      }

    } else {

      this.mobileLoginForm.classList.add('is-open');
    }
  }

  closeLoginForm(e) {

    if (e && e.relatedTarget === this.loginForm) {

      this.loginFormTrigger.classList.add('has-open-form');
      this.loginForm.addEventListener(this.closeFormListener, this.onCloseLoginForm, false);
      return;
    }

    if (e && e.preventDefault) {

      e.preventDefault();
    }

    if (!this.isTouch) {

      this.loginForm.removeEventListener(this.closeFormListener, this.onCloseLoginForm);
      this.loginForm.removeEventListener('focusin', this.onFormFocusHandler, false);

      this.loginFormTrigger.classList.remove('has-open-form');
      this.loginForm.classList.remove('is-open');
    }

    // if (this.isTouch && !this.isMobile) {
    //
    //   this.loginFormTrigger.classList.remove('is-active');
    // }
  }

  onFormFocus() {

    this.formFocusIsBound = true;

    if (!this.formCloseIsUnbound) {

      this.formCloseIsUnbound = true;
      this.loginForm.removeEventListener(this.closeFormListener, this.onCloseLoginForm, false);
    }

    document.addEventListener(standardListener, this.onFormClickOutsideHandler, false);
  }

  onFormClickOutside(e) {

    if (!isChildNode(e.target, this.loginForm)) {

      this.formFocusIsBound = false;
      this.formCloseIsUnbound = false;

      this.loginForm.addEventListener(this.closeFormListener, this.onCloseLoginForm, false);

      document.removeEventListener(standardListener, this.onFormClickOutsideHandler, false);

      this.closeLoginForm();
    }
  }

  openMobileLoginForm() {

    this.mobileLoginForm.classList.add('is-open');
  }

  closeMobileLoginForm() {

    this.mobileLoginForm.classList.remove('is-open');
  }

  onScroll() {

    const yOffset = window.pageYOffset;

    if (currentBreakpoint === 's' || currentBreakpoint === 'xs') {

      //this.el.classList.remove('is-forced-single');
      //return this.el.classList.toggle('is-single', yOffset > 50);

      if (yOffset > 50) {

        this.el.classList.add('is-single');

        if (document.querySelector('body').classList.contains('has-notification')) {

          document.querySelector('.app-notifications').classList.add('is-single');
        }

      } else {

        this.el.classList.remove('is-single');

        if (document.querySelector('body').classList.contains('has-notification')) {

          document.querySelector('.app-notifications').classList.remove('is-single');
        }
      }

      return false;

      //return (yOffset > 50) ? this.el.classList.add('is-single') : this.el.classList.remove('is-single');
    }

    // if (currentBreakpoint === 'm') {
    //
    //   this.isMobile = false;
    // }

    if (yOffset > this.offset) {

      if (this.isActive) {

        // if (currentBreakpoint === 'm') {
        //
        //   this.isMobile = true;
        // }

        return;
      }

      // this.el.classList.add('is-active');
      trigger(window, 'headerChange', {});

      if (this.cartEntry !== null) {

        this.el.addEventListener(animationEnd, this.onAddClasses);
      }

      if (this.search) {

        // reset search
        this.search.classList.remove('is-open');
      }

      this.isActive = true;

      return;
    }

    if (!this.isActive) {

      return;
    }

    if (this.search) {

      // reset search
      this.search.classList.remove('is-open');
    }

    this.isActive = false;

    // TODO: IE9 specific stuff...
    if (animationEnd !== undefined) {

      if (this.offCanvas) {

        this.offCanvas.classList.remove('is-open');
      }

      // this.el.classList.add('was-active');
      this.el.addEventListener(animationEnd, this.onRemoveClasses);
    } else if (animationEnd === undefined) {

      // this.el.classList.remove('is-active');
      trigger(window, 'headerChange', {});
    }
  }

  addClasses(e) {

    if (e.animationName === 'slide-in') {

      this.cartEntry.classList.add('is-sticky');
      this.cartContent.style.marginTop = this.cartEntryHeight + 'px';
      this.el.removeEventListener(animationEnd, this.onAddClasses);
    }
  }

  removeClasses(e) {

    if (e.animationName === 'fade-out') {

      this.el.removeEventListener(animationEnd, this.onRemoveClasses);
      this.el.addEventListener(animationEnd, this.onRemoveResettedClass);

      trigger(window, 'headerChange', {});
      // this.el.classList.remove('is-active');
      // this.el.classList.remove('was-active');
      // this.el.classList.add('is-resetted');

      if (this.cartEntry !== null) {

        this.cartContent.style.marginTop = '0px';
        this.cartEntry.classList.remove('is-sticky');
      }
    }
  }

  removeResettedClass(e) {

    if (e.animationName === 'slide-in') {

      // this.el.classList.remove('is-resetted');

      this.el.removeEventListener(animationEnd, this.onRemoveResettedClass);
    }
  }

  handleSearch(e) {


    if (!this.search) {

      return;
    }

    if (e) {

      e.preventDefault();
    }

    if (this.searchInput.value.length) {

      return this.search.submit();
    }
  }

  handleSubmit(e) {
    window._paq = window._paq || [];
    window._paq.push([
      'trackEvent',
      'Search',
      'submit',
      this.searchInput.value
    ]);
    window.setTimeout(() => {
      this.search.submit();
    }, 300);
    e.preventDefault();
  }

  outSideLoginFormClick(e) {

    if (e.target.contains(document.body)) {

      document.removeEventListener(standardListener, this.onOutSideLoginFormClick, false);

      this.loginForm.classList.remove('is-open');
      this.loginFormTrigger.classList.remove('is-active');

      return;
    }

    if (!getClosestByClass(e.target, 'login-form-wrapper')) {

      document.removeEventListener(standardListener, this.onOutSideLoginFormClick, false);

      this.loginForm.classList.remove('is-open');
      this.loginFormTrigger.classList.remove('is-active');
    }

  }

  outSideMenuDropdownClick() {

    const curElement = document.activeElement;

    if (curElement.classList.contains('is-nav')) {

      curElement.blur();
    }
  }

  outSideSearchClick(e) {
    if (!this.search) {

      return;
    }

    if (!getClosestByClass(e.target, 'search-container')) {
      document.removeEventListener(standardListener, this.onOutSideSearchClick, false);
      this.isOutsideClickHandlerRegistered = false;
      return this.search.classList.remove('is-open');
    }

  }

  stopBodyScrolling(bool) {
    if (bool === true) {
      document.body.addEventListener('touchmove', this.freezeVp, Modernizr.passiveeventlisteners ? {
        passive: true
      } : false);
    } else {
      document.body.removeEventListener('touchmove', this.freezeVp, Modernizr.passiveeventlisteners ? {
        passive: true
      } : false);
    }
  }

  freezeVp(e) {
    e.preventDefault();
  }

  scrollInChildList(e) {

    const childList = e.target.offsetParent;
    const childListHeight = e.target.offsetParent.clientHeight;
    const currentY = e.changedTouches[0].pageY;

    if (currentY > lastY) {
      // moved down
      distance -= 40;

      if (childList.scrollTo) {
        childList.scrollTo(0, distance);
      } else {
        childList.scrollTop = distance;
      }

    } else if (currentY < lastY) {

      if (distance > childListHeight) {

        distance = childListHeight;

      } else {

        distance += 40;
      }

      if (childList.scrollTo) {
        childList.scrollTo(0, distance);
      } else {
        childList.scrollTop = distance;
      }
    }

    lastY = currentY;
  }

  openMobileMenu(e) {

    e.preventDefault();
    this.closeUserMenu();
    this.search.classList.remove('is-open');
    this.offCanvas.classList.add('is-open');
    this.body.classList.add('has-menu-open');

    this.childLists.map(childList => {

      childList.addEventListener('touchmove', this.scrollInChildList.bind(this), Modernizr.passiveeventlisteners ? {
        passive: true
      } : false);
    });

    this.stopBodyScrolling(true);
  }

  touchEnd(linkEl, e) {

    if (linkEl.href && linkEl.href !== '#' && !linkEl.parentNode.classList.contains('has-child-list')) {

      window.location.href = linkEl.href;
      e.preventDefault();
    }
  }

  openSecondLevel(linkEl, e) {

    if (this.isMobile || this.isTouch) {

      if (!linkEl.parentNode.classList.contains('has-child-list')) {

        return;
      }

      e.preventDefault();

      if (e.target.classList.contains('has-child')) {

        return this.openThirdLevel(e);
      }

      this.activeSecondLevel = getClosestByClass(e.target, 'has-child-list');

      if (!this.activeSecondLevel.classList.contains('open-third-level')) {

        this.activeSecondLevel.classList.add('open-second-level');
      }
    }
  }

  openThirdLevel(e) {

    if (this.isMobile || this.isTouch) {

      this.activeSecondLevel.classList.add('no-scroll');

      this.activeThirdLevel = getClosestByClass(e.target, 'has-child-list');

      this.activeThirdLevel.classList.add('open-third-level');
    }
  }

  closeSecondLevel(e) {

    if (this.isMobile || this.isTouch) {

      if (e) {

        e.preventDefault();

        this.activeSecondLevel = getClosestByClass(e.target, 'has-child-list');
      }

      this.activeSecondLevel.classList.remove('open-second-level');
      this.activeSecondLevel = null;
    }
  }

  closeThirdLevel(e) {

    if (this.isMobile || this.isTouch) {

      if (e) {

        e.preventDefault();
      }

      this.activeThirdLevel.classList.remove('open-third-level');
      this.activeThirdLevel = null;

      this.activeSecondLevel.classList.remove('no-scroll');
    }
  }

  closeMobileMenu(e) {

    e.preventDefault();

    this.el.addEventListener(transitionEnd, this.onRemoveOffCanvasClass);
    this.offCanvas.classList.add('was-open');
    this.body.classList.remove('has-menu-open');

    //this.outerWraper.removeEventListener('touchmove', this.disableTouchHandler, false);

    this.stopBodyScrolling(false);
  }

  removeOffCanvasClass() {

    this.el.removeEventListener(transitionEnd, this.onRemoveOffCanvasClass);
    this.offCanvas.classList.remove('is-open');
    this.offCanvas.classList.remove('was-open');

    // TODO: reset all states from child and grand-child-lists
    if (this.activeThirdLevel) {

      this.closeThirdLevel(null);
    }

    if (this.activeSecondLevel) {

      this.closeSecondLevel(null);
    }
  }

  positionUserMenu() {

    if (this.userMenu === null) {

      return;
    }
    this.userMenu.style.width = '';
    if (currentBreakpoint !== 's' && currentBreakpoint !== 'xs') {

      let userMenuToggleDimensions = this.userMenuToggle.getBoundingClientRect();
      this.userMenu.style.width = userMenuToggleDimensions.width + 'px';
    }
  }

  closeUserMenu() {

    if (this.userMenu === null) {

      return;
    }
    if (!this.userMenu.classList.contains('is-open')) {

      return;
    }
    this.body.classList.remove('has-menu-open');
    this.userMenu.classList.remove('is-open');
  }

  openUserMenu() {

    if (this.userMenu === null) {

      return;
    }
    if (this.userMenu.classList.contains('is-open')) {

      return;
    }
    this.positionUserMenu();
    this.body.classList.add('has-menu-open');
    this.userMenu.classList.add('is-open');
  }

}

